import styled from 'styled-components';

export const StyledContainer = styled.div`
    padding: 16px;
    text-align: left;
`;

export const StyledInfoWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
`;

export const StyledLabel = styled.span`
    font-size: ${({ theme }) => theme.fontSize.verySmall};
`;

export const StyledValue = styled.span`
    font-weight: bold;
`;

export const StyledLoaderWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledTypeDetails = styled(StyledLabel)`
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.correct};
`;
